import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FavoriteComponent } from './favorite/favorite.component';
import { WebShareComponent } from './web-share/web-share.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MapComponent } from './map/map.component';
import { MarkerService } from '../services/marker.service';
import { DesktopRedirectPage } from './desktop-redirect/desktop-redirect.page';
import { LargeMapComponent } from './map/large-map/large-map.component';
import { LocationFilterComponent } from './location-filter/location-filter.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    FavoriteComponent,
    WebShareComponent,
    MapComponent,
    DesktopRedirectPage,
    LargeMapComponent,
    LocationFilterComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    MatRadioModule,
  ],
  exports: [
    BreadcrumbComponent,
    FavoriteComponent,
    WebShareComponent,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MapComponent,
    DesktopRedirectPage,
    LocationFilterComponent,
  ],
  providers: [MarkerService],
})
export class SharedModule {}
